import { Button, Input, Modal } from "antd";
import { isEmpty } from "lodash";
import { useState } from "react";
import styles from "./FeedbackModal.module.scss";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import { useDispatch, useSelector } from "react-redux";
import store from "../../../store";
import { studioActions } from "../../../store/studio";
import { logEvent } from "@uikit/service/amplitude";
import { useHomeUsePluginContainer } from "../../../custom-hooks/HomeUsePluginRoot";

type FeedbackModalProps = {
  onClose: () => void;
};

export const FeedbackModal: React.FC<FeedbackModalProps> = ({ onClose }) => {
  const { isNewEdgeRunRef } = useHomeUsePluginContainer();
  const [loading, setLoading] = useState(false);
  const [isSended, setIsSended] = useState(false);
  const [feedbackUserInputValue, setFeedbackUserInputValue] = useState("");

  const dispatch = useDispatch();
  const selectedTemplate = useSelector((state: any) => state.studio.selectedTemplate);
  const setSelectedTemplate = (val: any) => {
    dispatch(studioActions.setSelectedTemplate(val));
  };
  const cotSnapshotProjectId: any = store.getState().editor.cotSnapshotProjectId;
  const constructUrl = (cotSnapshotProjectId: String) => {
    return settings.ImagicaUrl + cotSnapshotProjectId;
  };

  const getFeedbackData = () => {
    try {
      const url = constructUrl(cotSnapshotProjectId);
      const feedbackData = {
        user_input: -1,
        // cot_input: selectedTemplate.v2.autoImagica.query,
        feedback_text: feedbackUserInputValue,
        project_id: cotSnapshotProjectId,
        url: url,
      };
      return feedbackData;
    } catch (error) {
      console.error(`getFeedbackData error: ${error}`);
    }
  };

  const handleClickClose = () => {
    onClose();
  };

  const handleClickCancel = () => {
    try {
      const dataVersion = isNewEdgeRunRef.current ? "v3" : "v2";
      logEvent("cot_graph_user_feedback_dislike_cancel", {
        ...getFeedbackData(),
        cot_input: selectedTemplate[dataVersion].autoImagica.query,
      });
    } catch (error) {
      console.error(`handleClickCancel error: ${error}`);
    }
    onClose();
  };

  const handleClickSend = async () => {
    setLoading(true);
    try {
      const cotFeedback = getFeedbackData();
      const dataVersion = isNewEdgeRunRef.current ? "v3" : "v2";
      logEvent("cot_graph_user_feedback_dislike", {
        ...cotFeedback,
        cot_input: selectedTemplate[dataVersion].autoImagica.query,
      });
      //save dislike to selectedTemplate
      const updatedProject = { ...selectedTemplate, v2: { ...selectedTemplate.v2, cotFeedback: cotFeedback } };
      setSelectedTemplate(updatedProject);
    } catch (error) {
      console.error(`handleClickSend error: ${error}`);
    }
    setLoading(false);
    setIsSended(true);
  };

  const handleChange: React.ChangeEventHandler<HTMLTextAreaElement> = event => {
    setFeedbackUserInputValue(event.target.value);
  };

  const submitText = loading === true ? "Submitting" : "Submit Feedback";

  const content =
    isSended === true ? (
      <div className={styles.content}>
        <img src={`${settings.S3CDN}${settings.viewAssetsPath}congratulations.svg`} alt="" />
        <div className={styles.title}>Thank You!</div>
        <p>We appreciate your feedback and will use it to help improve results.</p>
        <Button type="primary" onClick={handleClickClose}>
          Done
        </Button>
      </div>
    ) : (
      <div className={styles.content}>
        <div className={styles.title}>How can we improve the result</div>
        <p>How was the result of the AI helper's generated graph based on your query?</p>
        <Input.TextArea
          value={feedbackUserInputValue}
          onChange={handleChange}
          placeholder="Please describe how it can be better..."
          rows={4}
          autoSize={false}
        />
        <footer>
          <Button onClick={handleClickCancel}>Cancel</Button>
          <div className={styles.space} />
          <Button loading={loading} disabled={isEmpty(feedbackUserInputValue)} type="primary" onClick={handleClickSend}>
            {submitText}
          </Button>
        </footer>
      </div>
    );

  return (
    <Modal className={styles.feedbackModal} open={true} closable={false} centered footer={null}>
      {content}
    </Modal>
  );
};
